<template>
  <header class="container">
    <ul class="header-nav">
      <li class="link" v-for="item in items" :key="item.id" :class="{active: item.active}">
        <button
          class="btn-clear nav-link"
          :class="{active: item.active, completed: item.completed, [`btn-${item.name}`]: true}"
          @click="$emit('change-view', item)"
        >
          <span class="counter" :class="{active: item.counter}">
            <span>{{ item.counter }}</span>
          </span>
          <component :is="item.icon" />
          <span>{{ item.name }}</span>
        </button>
      </li>
      <slot />
    </ul>
  </header>
</template>

<script>
export default {
  props: {
    items: Array,
  },
};
</script>

<style scoped>
.header-nav {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
}

.last {
  margin-left: auto;
}

.link {
  list-style: none;
  padding: 0;
  padding: 20px 10px;
  position: relative;
  margin-bottom: -1px;
  display: flex;
  justify-content: center;
}

.link:after {
  content: '';
  position: absolute;
  bottom: 0;
  height: 1px;
  left: 0;
  right: 0;
  background: transparent;
  transition: all 0.25s cubic-bezier(0.65, 0, 0.45, 1);
}

.link.active:after {
  background: var(--primary-color, #2c70c9);
}

.link:hover:after {
  background-color: #c8c9c7;
}

.nav-link {
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  text-transform: uppercase;
  color: #a3abb6;
  font-size: 30px;
  position: relative;
}
.nav-link > span {
  padding: 15px 0 0 0;
  font-style: normal;
  font-weight: 700;
  font-size: 10px;
  line-height: 118.14%;
  text-align: center;
  letter-spacing: 0.195em;
}

.nav-link.active {
  color: var(--primary-color, #2c70c9);
}

.nav-link.completed:before {
  content: '';
  position: absolute;
  top: -7px;
  right: -2px;
  width: 26px;
  height: 26px;
  transform: translateX(50%);
  margin: -8px -8px 0 0;
  width: 26px;
  height: 26px;
  background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 3.47059L4.7037 7L11 1' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  background-size: 10px;
  background-position: 7px 8px;
  background-repeat: no-repeat;
  border-radius: 22px;
  border: 2px solid #fff;
  background-color: var(--primary-color, #2c70c9);
  opacity: 1;
  transform: none;
  transition: 0.3s ease opacity, 0.3s ease transform;
}

.counter {
  position: absolute;
  top: -15px;
  right: -10px;
  width: 26px;
  height: 26px;
  border-radius: 50px;
  background: var(--primary-color, #2c70c9);
  border: 2px solid #ffffff;
  box-sizing: border-box;
  transition: all 0.25s cubic-bezier(0.65, 0, 0.45, 1);
  opacity: 0;
}

.counter.active {
  opacity: 1;
}

.counter > span {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 118.14%;
  text-align: center;
  letter-spacing: -0.005em;
  color: #ffffff;
}

.btn-clear {
  background: none;
  border: none;
  -webkit-appearance: none;
}
</style>
